/* unplugin-vue-components disabled */import { render } from "./add-message.vue?vue&type=template&id=3400d08b&scoped=true"
import script from "./add-message.vue?vue&type=script&lang=js"
export * from "./add-message.vue?vue&type=script&lang=js"

import "./add-message.vue?vue&type=style&index=0&id=3400d08b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3400d08b"],['__file',"src/pages/playground/add-message.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3400d08b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3400d08b', __exports__)) {
    api.reload('3400d08b', __exports__)
  }
  
  module.hot.accept("./add-message.vue?vue&type=template&id=3400d08b&scoped=true", () => {
    api.rerender('3400d08b', render)
  })

}


export default __exports__